<script setup>
// The overview's period (phase 4.5): the kit's OptionSelect in the page header, with the woot's five periods.
// PROVISÓRIO as a period control (R2-7-3 → X-4 = B: the kit's presets for a period do not exist yet).
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import OptionSelect from 'dashboard/components-next/polaris/cards/OptionSelect.vue';

const modelValue = defineModel({ type: String, default: '30' });

const { t } = useI18n();

const DAY_RANGES = ['7', '30', '90'];

const options = computed(() => [
  ...DAY_RANGES.map(value => ({
    value,
    label: t('POLARIS.OVERVIEW.RANGES.LAST_DAYS', { count: value }),
  })),
  { value: 'this_month', label: t('POLARIS.OVERVIEW.RANGES.THIS_MONTH') },
  { value: 'last_month', label: t('POLARIS.OVERVIEW.RANGES.LAST_MONTH') },
]);
</script>

<template>
  <!-- OptionSelect's trigger is full width; the wrapper gives it the width of a header control. -->
  <div class="w-44">
    <OptionSelect
      v-model="modelValue"
      :options="options"
      size="sm"
      :aria-label="t('POLARIS.PAGES.OVERVIEW.RANGE_LABEL')"
    />
  </div>
</template>
